<template>
	<div class="modal-card reload_fintoc_card">
		<header class="modal-card-head has-background-white">
			<h3 class="modal-card-title has-text-centered">
				Recargar <span>{{ tipo }}</span> desde Fintoc
			</h3>
			<button class="delete" aria-label="Cerrar Modal" @click="$emit('close')"></button>
		</header>
		<section class="modal-card-body dates_section">
			<table class="fechas_table">
				<tr>
					<td class="fecha_title">Desde</td>
					<td class="fechas_td">
						<input class="fecha_input" type="date" name="desdeDate" :value="inidate">
					</td>
					<td class="fecha_title">Hasta</td>
					<td class="fechas_td">
						<input class="fecha_input" type="date" name="hastaDate" :value="today">
					</td>
				</tr>
			</table>
		</section>
		<section class="modal-card-body logs_section">
			<div class="log_title_wrap">
				<p class="log_title">Logs para la empresa {{ rutCompany }}</p>
				<img class="spinner" :src="spinner" v-if="intervalId" alt="Cargando" />
			</div>
			<table class="fintoc_log">
				<tr class="log_row log_header">
					<td class="log_cell">Periodo</td>
					<td class="log_cell">Fecha recepcion</td>
					<td class="log_cell">Filas recibidas</td>
					<td class="log_cell">Filas grabadas</td>
					<td class="log_cell">Error</td>
				</tr>
				<tr v-for="row in fintoc_logs" :key="row.id" class="log_row">
					<td class="log_cell">{{ row.tax_period }}</td>
					<td :class="['log_cell', 'log_fecha', { 'occurred_today': row.occurred_today }]">{{ row.received_date }}</td>
					<td class="log_cell">{{ row.rows_received }}</td>
					<td class="log_cell" :class="{ 'mismatch': row.rows_saved != row.rows_received }">{{ row.rows_saved }}</td>
					<td class="log_cell error_cell">
						<SimpleButton @click="showError(row)" v-if="row.error_expand">
							{{ row.expanded ? 'Contraer' : 'Ver error' }}
						</SimpleButton>
						{{ row.error_shown }}
					</td>
				</tr>
			</table>
		</section>
		<footer class="modal-card-foot bt-none has-background-white is-justify-content-flex-end">
			<button class="button" @click="$emit('close')" aria-label="Cerrar Modal" role="button">
				Volver
			</button>
			<button class="button is-primary"
				:disabled="loading || startYear == '' || startMonth == ''" role="button" @click="reloadData()">
				Recargar
			</button>
		</footer>
	</div>
</template>

<script>
import { updateObligationsFintoc, loadLogs } from "@/api/fintoc";
import { consoleHandlerError, notificate } from "@/utils/message";
import SimpleButton from "@/components/modals/SimpleButton";

export default {
	name: "ReloadFintocByCompany",
	components: {
		SimpleButton,
	},
	data() {
		return {
			publicPath: "http://" + window.location.hostname,
			actualYear: new Date().getFullYear(),
			loading: false,
			startYear: new Date().getFullYear() - 2,
			startMonth: '01',
			endYear: '',
			endMonth: '',
			today: '',
			inidate: '',
			fintoc_logs: [],
			company_id: '',
			intervalId: null,
		};
	},
	computed: {
		spinner: function () { return `${this.publicPath}/spinner.gif` },
		tipo: function() { return this.product == 'sii'? "Obligaciones": "Movimientos Bancarios"; },
	},
	mounted() {
		this.calculateDates();
		this.loadLogs(this.product);
	},
	methods: {
		showError(row) {
			if (!row.expanded) {
				row.expanded = true;
				row.error_shown = row.error_full;
			} else {
				row.expanded = false;
				row.error_shown = row.error_short;
			}
		},
		async loadLogs(product) {
			const result = await loadLogs(this.rutCompany, product);
			this.fintoc_logs = result.data;
		},
		calculateDates() {
			const today = new Date();
			this.today = today.toISOString().split('T')[0];

			const dateTwoYearsAgo = new Date(today.setFullYear(today.getFullYear() - 2));
			this.inidate = dateTwoYearsAgo.toISOString().split('T')[0];
		},
		reloadData() {
			this.loading = true
			let untilAux = this.endYear + '-' + this.endMonth + '-01'
			if (this.endYear == '' || this.endMonth == '') {
				untilAux = this.today
			}
			let data = {
				since: this.startYear + '-' + this.startMonth + '-01',
				until: untilAux,
				company: this.rutCompany,
				product: this.product
			}
			updateObligationsFintoc(data).then(({ data }) => {
				notificate(
					`<strong>Éxito!</strong><br>
					` + data,
					"is-success is-light"
				);
				this.intervalId = setInterval(() => {
					this.loadLogs(this.product);
				}, 5000);
			}).catch(error => {
				consoleHandlerError({ error, empty: true });
				this.$emit("close");
			}).finally(() => {
				this.loading = false
			})
		},
	},
	props: ["rutCompany", "product"],
	beforeDestroy() {
		if (this.intervalId) {
			clearInterval(this.intervalId);
		}
	},
};
</script>
<style scoped lang="scss">
// Tema del analista (var(--ap-*), elements/_analyst_theme.scss).
// Acción de recarga/destructiva: el énfasis va con los tokens de alerta.
.reload_fintoc_card {
	font-family: var(--ap-font);
	color: var(--ap-ink-2);
	width: min(720px, 94vw);
	display: flex;
	flex-direction: column;
	max-height: 86vh;
	background-color: var(--ap-paper);
	border-radius: var(--ap-radius);
	overflow: hidden;
}

.modal-card-head {
	border-bottom: 1px solid var(--ap-line);
}

::v-deep .modal-card-title {
	font-family: var(--ap-font);
	font-weight: 700;
	font-size: 20px;
	letter-spacing: -0.01em;
	color: var(--ap-ink);
}

.dates_section {
	padding: 22px;
	border-bottom: 1px solid var(--ap-line);
	background-color: var(--ap-paper);
}

.fechas_table {
	width: 100%;

	td {
		border: none;
	}
}

.fecha_title {
	font-weight: 600;
	font-size: 13px;
	color: var(--ap-slate);
	padding: 2px 10px 0 0;
	white-space: nowrap;
}

.fechas_td {
	width: 40%;
}

.fecha_input {
	width: 100%;
	padding: 8px 11px;
	border: 1px solid var(--ap-line-strong);
	border-radius: var(--ap-radius-sm);
	font-family: var(--ap-font);
	font-size: 13.5px;
	color: var(--ap-ink);
	background-color: var(--ap-paper);
	transition: border-color 0.14s var(--ap-ease), box-shadow 0.14s var(--ap-ease);

	&:focus {
		outline: none;
		border-color: var(--ap-teal);
		box-shadow: 0 0 0 3px var(--ap-teal-wash);
	}

	&:focus-visible {
		outline: 2px solid var(--ap-teal);
		outline-offset: 1px;
	}
}

.logs_section {
	flex: 1;
	overflow: hidden auto;
	padding: 18px 22px 22px;
	background-color: var(--ap-paper);
}

.log_title_wrap {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	margin-bottom: 14px;
}

.log_title {
	text-align: center;
	font-weight: 600;
	font-size: 14px;
	color: var(--ap-ink);
}

.spinner {
	width: 34px;
	height: 34px;
}

.fintoc_log {
	width: 100%;
	border-collapse: collapse;
}

.log_cell {
	border: 1px solid var(--ap-line-strong);
	padding: 5px 10px;
	font-size: 13px;
	color: var(--ap-ink-2);
}

.log_fecha {
	font-size: 90%;
	padding-top: 2px;
}

.log_header {
	.log_cell {
		background-color: var(--ap-mist);
		color: var(--ap-slate);
		font-weight: 600;
		font-size: 11px;
		letter-spacing: 0.06em;
		text-transform: uppercase;
	}
}

// Discrepancia filas grabadas ≠ recibidas → énfasis de alerta.
.mismatch {
	background-color: var(--ap-alert-wash);
	color: var(--ap-alert);
	font-weight: 600;
}

// Recepción del día → resaltado positivo (recibido recientemente).
.occurred_today {
	background-color: var(--ap-ok-wash);
	color: var(--ap-ok-ink);
	font-weight: 600;
}

// Botón "Ver error" (SimpleButton compartido): lo reestilamos como pill de
// alerta dentro de este modal sin tocar el componente. La clase extra en el
// <td> sube la especificidad por encima de los estilos propios del hijo.
.error_cell ::v-deep .simple_button {
	border: 1px solid var(--ap-alert-wash);
	border-radius: var(--ap-radius-pill);
	padding: 3px 12px;
	margin: 0;
	background-color: var(--ap-alert-wash);
	color: var(--ap-alert);
	font-family: var(--ap-font);
	font-size: 12px;
	font-weight: 600;
	filter: none;
	transition: background-color 0.14s var(--ap-ease), transform 0.14s var(--ap-ease);

	&:hover {
		padding: 3px 12px;
		transform: translateY(-1px);
		border-color: var(--ap-alert);
		background-color: var(--ap-alert-wash);
		filter: none;
	}

	&:active {
		transform: translateY(0);
		background-color: var(--ap-alert-wash);
	}

	&:focus-visible {
		outline: 2px solid var(--ap-alert);
		outline-offset: 1px;
	}
}

.button {
	border-radius: var(--ap-radius-pill);
	border: 1px solid var(--ap-line-strong);
	font-family: var(--ap-font);
	font-weight: 600;
	color: var(--ap-slate);
	transition: transform 0.14s var(--ap-ease), background-color 0.14s var(--ap-ease), border-color 0.14s var(--ap-ease);

	&:focus-visible {
		outline: 2px solid var(--ap-teal);
		outline-offset: 1px;
	}
}

.button.is-primary {
	border-color: transparent;
	background-color: var(--ap-ink);
	color: var(--ap-paper);

	&:hover {
		transform: translateY(-1px);
		background-color: var(--ap-teal-deep);
	}

	&:active {
		transform: translateY(0);
	}

	&:disabled {
		background-color: var(--ap-mist);
		color: var(--ap-muted);
		transform: none;
		cursor: not-allowed;
	}
}
</style>
